"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Pdf = function Pdf(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", {
    strokeMiterlimit: 50,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 6.237,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.926 3.163H21.038c-4.941 0-8.972 4.03-8.972 8.972V83.91c0 4.99 4.03 8.971 8.972 8.971H74.87a8.928 8.928 0 0 0 8.972-8.971V30.079z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.974 3.163v26.916h26.915M65.945 52.82H30.058m35.887 15.4H30.058m8.972-30.225h-8.972"
  }))));
};
var _default = exports.default = Pdf;